/**
 * Lobby-related constants
 *
 * These enums provide runtime-accessible values for lobby status
 * and room types used in the lobby system.
 */

/**
 * Lobby status enum
 * Use these instead of string literals like 'waiting' or 'in-progress'
 */
export enum LobbyStatusEnum {
  WAITING = 'waiting',
  READY = 'ready',
  STARTING = 'starting',
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

/**
 * Background room type enum
 * Use these instead of string literals like 'tavian' or 'party'
 */
export enum RoomTypeEnum {
  TAVIAN = 'tavian',
  ALDRIC = 'aldric',
  KIRA = 'kira',
  GROLT = 'grolt',
  INNER = 'inner',
  PARTY = 'party',
  PRIVATE = 'private',
  LOBBY = 'lobby',
  ONE_TO_ONE = '1to1',
}

/** Room ID prefix for inner voice (player-character 1:1) chat */
export const INNER_VOICE_ROOM_PREFIX = 'inner-';

/**
 * Player ready state enum
 * Use these instead of string literals like 'ready' or 'not-ready'
 */
export enum PlayerReadyStateEnum {
  NOT_READY = 'not-ready',
  READY = 'ready',
  IN_GAME = 'in-game',
}

/**
 * Lobby visibility enum
 */
export enum LobbyVisibilityEnum {
  PUBLIC = 'public',
  PRIVATE = 'private',
  FRIENDS_ONLY = 'friends-only',
}

/**
 * Module difficulty enum
 */
export enum ModuleDifficultyEnum {
  EASY = 'easy',
  MEDIUM = 'medium',
  HARD = 'hard',
  DEADLY = 'deadly',
}

/**
 * Campaign length enum
 */
export enum CampaignLengthEnum {
  ONE_SHOT = 'one-shot',
  SHORT = 'short',
  MEDIUM = 'medium',
  LONG = 'long',
  EPIC = 'epic',
}

/**
 * The adventure a quick-start lands in when the caller names none.
 *
 * Mirror of `DEFAULT_QUICK_START_MODULE_ID` in
 * `backend/lobby-server/src/constants.rs`. Pass it explicitly when the UI
 * NAMES the adventure in its copy: an absent id means "keep whatever the
 * party already pinned", which would send a player who was promised Goldvale
 * somewhere else.
 */
export const DEFAULT_QUICK_START_MODULE_ID = 'goldvales_last_hope';
